import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    
    /** 获取分类列表 **/
    GET_TUTARIAL_CATE_LIST(data) {
        controller='Tutarial';
        action='GetCateList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增分类 **/
    ADD_TUTARIAL_CATE(data) {
        controller='Tutarial';
        action='AddCate';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取分类信息 **/
    GET_TUTARIAL_CATE_INFO(data) {
        controller='Tutarial';
        action='GetCateInfos';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 编辑分类信息 **/
    EDIT_TUTARIAL_CATE(data) {
        controller='Tutarial';
        action='EditCate';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除分类信息 **/
    DEL_TUTARIAL_CATE(data) {
        controller='Tutarial';
        action='DelCate';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取教程列表 **/
    GET_TUTARIAL_LIST(data) {
        controller='Tutarial';
        action='GetTutarialList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增教程 **/
    ADD_TUTARIAL(data) {
        controller='Tutarial';
        action='AddTutatial';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取教程信息 **/
    GET_TUTARIA_INFO(data) {
        controller='Tutarial';
        action='GetTutatialInfo';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 编辑教程信息 **/
    EDIT_TUTARIA(data) {
        controller='Tutarial';
        action='EditTutatial';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除教程信息 **/
    DEL_TUTARIA(data) {
        controller='Tutarial';
        action='DelTutarial';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },
   
}